import React from 'react';
import { Helmet } from 'react-helmet-async';
import s from './Contacts.module.scss';

const Contacts = () => {
  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>ЛАОЛА | КОНТАКТИ</title>
        <meta
          name="description"
          content="ЛАОЛА - ваш провідник в світ домашнього інтерʼєру. Кухні, меблі, міжкімнатні двері та багато іншого. Проектування і монтаж."
        />
      </Helmet>
      <div className={s.contacts}>
        <h1 className={s.contacts___title}>КОНТАКТИ</h1>

        <div className={s.contacts___wrap}>
          <p className={s.contacts__label}>Телефон:</p>
          <a href="tel:+380679420901" className={s.contacts__phone}>
            (067)942 09 01
          </a>
          <a href="tel:+380739420901" className={s.contacts__phone_2}>
            (073)942 09 01
          </a>
        </div>

        <div className={s.contacts___wrap}>
          <p className={s.contacts__label}>Пошта:</p>
          <a href="mailto:laola.wood@gmail.com" className={s.contacts__mail}>
            laola.wood@gmail.com
          </a>
        </div>

        <div className={s.contacts___wrap}>
          <p className={s.contacts__label}>Соцмережі:</p>
          <a
            href="https://www.instagram.com/larindoors49?igsh=MXBtcWJkYXNoa3E2YQ=="
            className={s.contacts__instagram}
          >
            <svg
              className={s.contacts__instagram__svg}
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
            >
              <path d="M24.000048,0 C17.481991,0 16.664686,0.027628 14.104831,0.144427 C11.550311,0.260939 9.805665,0.666687 8.279088,1.260017 C6.700876,1.873258 5.362454,2.693897 4.028128,4.028128 C2.693897,5.362454 1.873258,6.700876 1.260017,8.279088 C0.666687,9.805665 0.260939,11.550311 0.144427,14.104831 C0.027628,16.664686 0,17.481991 0,24.000048 C0,30.518009 0.027628,31.335314 0.144427,33.895169 C0.260939,36.449689 0.666687,38.194335 1.260017,39.720912 C1.873258,41.299124 2.693897,42.637546 4.028128,43.971872 C5.362454,45.306103 6.700876,46.126742 8.279088,46.740079 C9.805665,47.333313 11.550311,47.739061 14.104831,47.855573 C16.664686,47.972372 17.481991,48 24.000048,48 C30.518009,48 31.335314,47.972372 33.895169,47.855573 C36.449689,47.739061 38.194335,47.333313 39.720912,46.740079 C41.299124,46.126742 42.637546,45.306103 43.971872,43.971872 C45.306103,42.637546 46.126742,41.299124 46.740079,39.720912 C47.333313,38.194335 47.739061,36.449689 47.855573,33.895169 C47.972372,31.335314 48,30.518009 48,24.000048 C48,17.481991 47.972372,16.664686 47.855573,14.104831 C47.739061,11.550311 47.333313,9.805665 46.740079,8.279088 C46.126742,6.700876 45.306103,5.362454 43.971872,4.028128 C42.637546,2.693897 41.299124,1.873258 39.720912,1.260017 C38.194335,0.666687 36.449689,0.260939 33.895169,0.144427 C31.335314,0.027628 30.518009,0 24.000048,0 Z M24.000048,4.324317 C30.40826,4.324317 31.167356,4.348801 33.69806,4.464266 C36.038036,4.570966 37.308818,4.961946 38.154513,5.290621 C39.274771,5.725997 40.074262,6.246066 40.91405,7.08595 C41.753934,7.925738 42.274003,8.725229 42.709379,9.845487 C43.038054,10.691182 43.429034,11.961964 43.535734,14.30194 C43.651199,16.832644 43.675683,17.59174 43.675683,24.000048 C43.675683,30.40826 43.651199,31.167356 43.535734,33.69806 C43.429034,36.038036 43.038054,37.308818 42.709379,38.154513 C42.274003,39.274771 41.753934,40.074262 40.91405,40.91405 C40.074262,41.753934 39.274771,42.274003 38.154513,42.709379 C37.308818,43.038054 36.038036,43.429034 33.69806,43.535734 C31.167737,43.651199 30.408736,43.675683 24.000048,43.675683 C17.591264,43.675683 16.832358,43.651199 14.30194,43.535734 C11.961964,43.429034 10.691182,43.038054 9.845487,42.709379 C8.725229,42.274003 7.925738,41.753934 7.08595,40.91405 C6.246161,40.074262 5.725997,39.274771 5.290621,38.154513 C4.961946,37.308818 4.570966,36.038036 4.464266,33.69806 C4.348801,31.167356 4.324317,30.40826 4.324317,24.000048 C4.324317,17.59174 4.348801,16.832644 4.464266,14.30194 C4.570966,11.961964 4.961946,10.691182 5.290621,9.845487 C5.725997,8.725229 6.246066,7.925738 7.08595,7.08595 C7.925738,6.246066 8.725229,5.725997 9.845487,5.290621 C10.691182,4.961946 11.961964,4.570966 14.30194,4.464266 C16.832644,4.348801 17.59174,4.324317 24.000048,4.324317 Z M24.000048,11.675683 C17.193424,11.675683 11.675683,17.193424 11.675683,24.000048 C11.675683,30.806576 17.193424,36.324317 24.000048,36.324317 C30.806576,36.324317 36.324317,30.806576 36.324317,24.000048 C36.324317,17.193424 30.806576,11.675683 24.000048,11.675683 Z M24.000048,32 C19.581701,32 16,28.418299 16,24.000048 C16,19.581701 19.581701,16 24.000048,16 C28.418299,16 32,19.581701 32,24.000048 C32,28.418299 28.418299,32 24.000048,32 Z M39.691284,11.188768 C39.691284,12.779365 38.401829,14.068724 36.811232,14.068724 C35.22073,14.068724 33.931276,12.779365 33.931276,11.188768 C33.931276,9.598171 35.22073,8.308716 36.811232,8.308716 C38.401829,8.308716 39.691284,9.598171 39.691284,11.188768 Z" />
            </svg>
          </a>
        </div>

        <div className={s.contacts___wrap}>
          <p className={s.contacts__label}>Адреса:</p>
          <p className={s.contacts__address}>
            Виробництво - Київ, вул. Родини Бунге, 7
          </p>
        </div>
      </div>

      <div className={s.map}>
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCBTo_2EvnjalL-l5cQ9NE9BGLZMqsPMLU&q=ТОВ+ЛАОЛА,Rodyny+Bunge+St+7,Kyiv+Ukraine,02000&language=uk"
          width="600"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          style={{
            width: '100%',
            '@media screen and (max-width: 480px)': {
              width: '400px',
            },
          }}
        ></iframe>
      </div>
    </>
  );
};

export default Contacts;
